import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { CurrencyMaskInputMode, NgxCurrencyModule } from "ngx-currency";
import { EditorModule } from '@tinymce/tinymce-angular';
import { MaterialModule } from './material.module';
import { NgxMaskModule } from 'ngx-mask';

import { ControlErrorModule } from './directives/control-error/control-error.module';
import { Directives } from './directives/_directives';
import { MatTableResponsiveModule } from './directives/mat-table-responsive/mat-table-responsive.module';
import { Pipes } from './pipes/_pipes';


export const CustomCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true,
  min: null,
  max: null,
  inputMode: CurrencyMaskInputMode.FINANCIAL
};

@NgModule({
  imports: [
    CommonModule,
    ControlErrorModule,
    EditorModule,
    FlexLayoutModule,
    HttpClientModule,
    MatTableResponsiveModule,
    MaterialModule,
    NgxCurrencyModule.forRoot(CustomCurrencyMaskConfig),
    NgxMaskModule.forRoot(),
    ReactiveFormsModule,
  ],
  exports: [
    Directives,
    MaterialModule,
    ControlErrorModule,
    FlexLayoutModule,
    NgxMaskModule,
    MatTableResponsiveModule,
    Pipes,
    ReactiveFormsModule,
  ],
  declarations: [
    Directives,
    Pipes,
  ],
  providers: [
    Pipes,
  ]
})
export class CoreModule { }
